export default [
  {
    header: 'Scadenze',
    resource: 'scadenze',
    action: 'read',
  },
]
